import React from 'react';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const UnableToProceed = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcApp.UnableToProceed.s4',
    'You cannot without private parking spaces - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const handleBtnClick = () => {
    window.location.assign('/dashboardHub/dashboard-pmc');
  };
  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'pmcApp.UnableToProceed.s1',
          'You cannot proceed'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcApp.UnableToProceed.s2',
          'You are not able to apply for this grant because the property must have private parking.'
        )}
      </p>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcApp.UnableToProceed.s3',
          'Cancel my application'
        )}
      </Button>
    </>
  );
};

export default UnableToProceed;
